//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    mini: {
      default: null
    },
    selections: {
      default: []
    },
    betType: {
      default: null
    }
  },
  methods: {
      currentClass(betType) {

        let className = "text-gray-50";
        let classBorder = "border-transparent";
        if(betType == 'combi' && this.selections.length > 1) {
          className = "text-gray-50";
        }
        if(betType == 'system' && this.selections.length > 2) {
          className = "text-gray-50";
        }
        if(betType == this.betType) {
          className = "font-bold text-white border-primary ";
          classBorder = "border-primary";
        } else {
        }

        //if disabled
        if(betType == 'combi' && this.selections.length <= 1) {
          className = "text-gray-50 cursor-pointer";
        }
        if(betType == 'system' && this.selections.length < 3) {
          className = "text-gray-50 cursor-pointer";
        }
        if(betType == 'system' && this.selections.length > 16) {
          className = "text-gray-50 cursor-pointer";
        }


        //if disabled
        if(betType == 'combi') {
          let dup_events = _.map(this.selections, 'event.id').reduce((acc, v, i, arr) => (arr.indexOf(v) !== i && acc.indexOf(v) === -1 ? acc.concat(v) : acc), [])
          if(_.size(dup_events) > 0)
            className = "text-gray-50 cursor-pointer";
        }
        if(betType == 'system') {
          let dup_events = _.map(this.selections, 'event.id').reduce((acc, v, i, arr) => (arr.indexOf(v) !== i && acc.indexOf(v) === -1 ? acc.concat(v) : acc), [])
          if(_.size(dup_events) > 0)
            className = "text-gray-50 cursor-pointer";
        }

        return className + ' ' + classBorder
      },
      selectBetType(betType) {
        this.$emit('selectBetType', betType)
      }
  }
}
